"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardAligned = CardAligned;
exports.CardBody = CardBody;
exports.CardButtons = CardButtons;
exports.CardTitle = CardTitle;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

require("./CardAligned.styles.css");

var _excluded = ["children", "formProps", "onFormSubmit", "paperProps"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function CardAligned(_ref) {
  var children = _ref.children,
      formProps = _ref.formProps,
      onFormSubmit = _ref.onFormSubmit,
      paperProps = _ref.paperProps,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("div", props, /*#__PURE__*/_react["default"].createElement(_material.Paper, _extends({}, paperProps, {
    style: {
      height: '100%'
    }
  }), /*#__PURE__*/_react["default"].createElement("form", _extends({
    className: "CardAligned_container",
    onSubmit: onFormSubmit
  }, formProps), children)));
}

function CardBody(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "CardAligned_body"
  }, children);
}

function CardButtons(_ref3) {
  var children = _ref3.children;
  return children && /*#__PURE__*/_react["default"].createElement("div", {
    className: "CardAligned_buttons"
  }, children);
}

function CardTitle(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "CardAligned_title"
  }, children);
}

CardAligned.propTypes = {
  formProps: _propTypes["default"].object,
  onFormSubmit: _propTypes["default"].func,
  paperProps: _propTypes["default"].object
};
var _default = {
  CardAligned: CardAligned,
  CardBody: CardBody,
  CardButtons: CardButtons,
  CardTitle: CardTitle
};
exports["default"] = _default;